import { useRecoilValue } from "recoil";
import { authAtom } from "stores";

export default function useChmod() {
  const auth = useRecoilValue(authAtom);

  const chmod = (section: PermissionSectionsT, action: PermissionSectionActionsT) => {
    return auth?.permissions
      .filter((e) => e.section?.route === section)
      ?.some((e) => e.action === action);
  };

  const factorStepChmod = (stepID: string) => {
    return auth?.permissions
      .filter((e) => e.section?.route === "factor")
      ?.some((e) => e.action === stepID);
  };
  const factorStepsAllowed = () => {
    return auth.permissions?.filter((e) => e.type === "factor-type").map((e) => e.action);
  };

  return { chmod, factorStepChmod, factorStepsAllowed };
}
